<template>
  <!--行业大会-->
  <div
    style="
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
	  padding-top: 60px;
    "
    v-if="professionList"
  >
    <Breadcrumb
      :value="[$t('h.tabName1'), $t('h.tabName5'), $t('h.tabName5Item1')]"
    />
    <div
      style="
        width: 1200px;
        height: auto;
        padding: 0 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
      "
    >
      <div class="baseTitle" style="padding: 60px 0">
        {{ professionList[$language === "ZH" ? "itemsCn" : "itemsEn"].title }}
      </div>
      <div style="display: flex">
        <div
          style="
            width: 637px;
            height: 390px;
            margin-right: 12px;
            overflow: hidden;
            border-radius: 12px;
          "
        >
          <img
            :src="
              professionList[$language === 'ZH' ? 'itemsCn' : 'itemsEn']
                .coverImage
            "
            class="customImage"
          />
        </div>
        <div
          style="
            width: 527px;
            height: 390px;
            background: #fafafa;
            border-radius: 12px;
            padding: 18px 12px 40px 12px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
          "
        >
          <!--          class = customLabel-->
          <div
            style="
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 8;
              overflow: hidden;
              word-break: break-all;
			  text-align: justify;
            "
            class="baseContent"
            v-html="
              professionList[$language === 'ZH' ? 'itemsCn' : 'itemsEn']
                .description
            "
          ></div>
          <!-- 暂时隐藏报名入口 -->
          <!-- <a-button
            class="customBtn"
            @click="openModal"
            style="
              width: 85%;
              height: 48px;
              background: #d7000F;
              border-radius: 2px;
              border: none;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <img
              src="@/assets/img/baomingrukou.png"
              style="width: 24px; height: 24px"
            />
            <div
              style="
                font-family: SourceHanSansCN-Medium;
                font-size: 20px;
                color: #ffffff;
                padding-left: 4px;
                line-height: 22px;
              "
            >
              {{ $t("h.custom.SignUp") }}
            </div>
          </a-button> -->
        </div>
      </div>
      <!-- 暂时隐藏议程列表 -->
      <!-- <div style="padding: 60px 24px; width: 100%">
        <a-table
          :dataSource="professionList.meetings"
          :columns="columns"
          :pagination="false"
        >
          <div slot="time" slot-scope="text, record" class="tableValue">
            {{ record.startTime + " - " + record.endTime }}
          </div>
          <div slot="tit" slot-scope="text, record" class="tableValue">
            {{ record[$language === "ZH" ? "titleCn" : "titleEn"] }}
          </div>
          <div
            slot="custom"
            slot-scope="text, record"
            class="tableValue"
            style="
              display: flex;
              align-items: flex-start;
              justify-content: center;
              flex-direction: column;
            "
          >
            <div>
              {{ record[$language === "ZH" ? "authorCn" : "authorEn"] }}
            </div>
          </div>
        </a-table>
        <div
          style="
            font-family: SourceHanSansCN-Medium;
            font-size: 14px;
            color: #333333;
            text-align: right;
            line-height: 22px;
            padding-top: 10px;
          "
        >
          {{ $t("h.custom.PleaseReferToTheOnSiteAnnouncement") }}
        </div>
      </div> -->
      <div class="list-container">
        <div class="list-item" v-for="(item, index) in imgList" :key="index">
          <div style="display: flex; flex-direction: column">
            <div
              style="
                width: 100%;
                height: 203px;
                border-radius: 4px;
                overflow: hidden;
              "
            >
              <img :src="item.url" class="customImage" />
            </div>
          </div>
        </div>
      </div>
    </div>

 <a-modal
      v-model="visible"
      :title="$t('h.Conference.ConferenceRegistration')"
      on-ok="handleOk"
      centered
    >
      <template slot="footer">
        <div>
          <a-button
            class="customBtn"
            style="
              border: none;
              background: #d7000F;
              border-radius: 4px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #ffffff;
              text-align: center;
              line-height: 22px;
            "
            key="submit"
            :loading="loading"
            @click="handleOk"
          >
            {{ $t("h.custom.Yes") }}
          </a-button>
          <a-button
            class="customBtn"
            style="
              background: #fafafa;
              border: 1px solid #dddddd;
              border-radius: 4px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #666666;
              text-align: center;
              line-height: 22px;
            "
            key="back"
            @click="handleCancel"
          >
            {{ $t("h.custom.No") }}
          </a-button>
        </div>
      </template>
      <div v-if="formFieldsList.length">
        <a-form-model
          ref="ruleForm"
          layout="vertical"
          :model="form"
          style="display: flex; flex-wrap: wrap"
        >
          <a-form-model-item
            v-for="(domain, index) in form.domains"
            :key="domain.id"
            :label="domain.title"
            style="width: 48%; margin: 0 1%"
            :prop="'domains.' + index + '.value'"
            :rules="{
              required: domain.required,
              message: $t('h.custom.PleaseEnter', { value: domain.title }),
              trigger: 'blur',
            }"
          >
            <a-input
              v-if="domain.fieldType === 'Text'"
              v-model="domain.value"
            />
            <a-select
              v-model="domain.value"
              allowClear
              v-else-if="domain.fieldType === 'Select'"
            >
              <a-select-option
                :value="selectItem"
                :key="selectItem"
                v-for="selectItem in domain.defaultValue"
              >
                {{ selectItem }}
              </a-select-option>
            </a-select>

            <a-upload
              :customRequest="formUpload"
              :multiple="domain.fieldType === 'MutiUpload'"
              @change="handleUploadChange($event, index)"
              v-else-if="
                domain.fieldType === 'Upload' ||
                domain.fieldType === 'MutiUpload'
              "
            >
              <a-button
                :disabled="domain.fieldType !== 'MutiUpload' && !!domain.value"
              >
                {{ $t("h.custom.Upload") }}
              </a-button>
            </a-upload>
          </a-form-model-item>
        </a-form-model>
        <div
          v-if="mtForms.description || mtForms.descriptionEn"
          class="mt-2 whitespace-pre-line"
        >
          {{ $language == "ZH" ? mtForms.description : mtForms.descriptionEn }}
        </div>
      </div>
    </a-modal>
  </div>
  <div style="height: 200px" v-else></div>
</template>

<script>
import { getFormsById, queryArticlePageList, saveReport } from "@/assets/api";
import { upload } from "../../../assets/api";

import conferrence1 from "@/assets/img/industryConference/1.jpg";
import conferrence2 from "@/assets/img/industryConference/2.jpg";
import conferrence3 from "@/assets/img/industryConference/3.jpg";
import conferrence4 from "@/assets/img/industryConference/4.jpg";
import conferrence5 from "@/assets/img/industryConference/5.jpg";
import conferrence6 from "@/assets/img/industryConference/6.jpg";
import conferrence7 from "@/assets/img/industryConference/7.jpg";

export default {
  name: "IndustryConference",
  data() {
    return {
      ruleForm: null,
      form: {
        domains: [],
      },
      rules: {},
      loading: false,
      visible: false,
      professionList: null,
      formFieldsList: [],

      mtForms: {},
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      imgList: [
        {
          url: conferrence1,
        },
        {
          url: conferrence2,
        },
        {
          url: conferrence3,
        },
        {
          url: conferrence4,
        },
        {
          url: conferrence5,
        },
        {
          url: conferrence6,
        },
        //{
        //  url: conferrence7,
        //},
      ],
      dataSource: [],
      columns: [
        {
          title: this.$t("h.custom.Time"),
          dataIndex: "time",
          key: "time",
          align: "center",
          scopedSlots: { customRender: "time" },
        },
        {
          title: this.$t("h.custom.Topic"),
          dataIndex: "title",
          key: "title",
          align: "center",
          scopedSlots: { customRender: "tit" },
        },
        {
          title: this.$t("h.custom.Speaker"),
          dataIndex: "custom",
          key: "custom",
          scopedSlots: { customRender: "custom" },
          align: "center",
          width: 300,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleUploadChange(event, index) {
      this.form.domains[index].value = event.fileList
        .filter((it) => !!it.response)
        .filter((it) => !!it.response.url)
        .map((it) => it.response.url)
        .join(",");
    },
    formUpload({ file, onError, onSuccess }) {
      const formData = new FormData();
      formData.append("file", file);
      this.$axios.post(upload, formData).then((res) => {
        if (res && res.data.success) {
          onSuccess({ url: res.data.message });
        } else {
          onError(new Error(res.data.message), file);
        }
      });
    },
    getList() {
      this.$axios
        .get(queryArticlePageList + "?code=C09A01&pageSize=1", {})
        .then((res) => {
          if (res.data.success) {
            this.professionList = res.data.result.records.length
              ? res.data.result.records[0]
              : null;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    getFormData(id) {
      id = this.professionList.linkFormId;
      this.$axios.get(getFormsById + "/" + id, {}).then((res) => {
        if (res.data.success) {
          this.mtForms = res.data.result.mtForms;
          this.formFieldsList = res.data.result.formFieldsList;
          this.mtForms = res.data.result.mtForms;
          this.form.domains = [];
          this.formFieldsList.forEach((item) => {
            this.form.domains.push({
              value: null,
              id: item.id,
              title: this.$language === "ZH" ? item.title : item.titleEn,
              required: item.isRequired === "Y",
              fieldType: item.fieldType,
              defaultValue:
                item.fieldType === "Select" ? item.defaultValue.split(",") : [],
            });
          });
          this.visible = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    openModal(id) {
      // if (!localStorage.getItem("token")) {
      //   this.$message.info(this.$t("h.toRegister"));
      //   setTimeout(() => {
      //     this.$router.push({
      //       path: "/vistor/register-gz",
      //       query: {
      //         scene: "apply",
      //       },
      //     });
      //   }, 1000);
      //   return false;
      // }
      // this.getFormData(id);
	  const conferenceUrl = "https://ceeia-ecwb.mike-x.com/JABKJ"; // 替换为实际注册链接
	  				    
	  				    // 通用跳转方案（无需判断观众身份）
	  				    // #ifdef H5
	  				    window.location.href = conferenceUrl;
	  				    // #endif
	  				    
	  				    // #ifdef APP-PLUS
	  				    plus.runtime.openURL(conferenceUrl);
	  				    // #endif
	  				    
	  				    // #ifdef MP-WEIXIN
	  				    wx.navigateTo({
	  				      url: `/pages/webview/webview?url=${encodeURIComponent(conferenceUrl)}`
	  				    });
	  				    // #endif
    },
    handleOk(e) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$axios
            .post(saveReport, {
              userData: JSON.stringify(this.form.domains).toString(),
              formId: this.mtForms.id,
              articleId: this.professionList.id,
            })
            .then((res) => {
              if (res && res.data.success) {
                this.$message.success(
                  res.data.message || this.$t("h.custom.SignUpTips")
                );
                setTimeout(() => {
                  this.visible = false;
                  this.loading = false;
                  this.ruleForm.resetFields();
                }, 1000);
              } else {
                this.$message.error(res.data.message);
                setTimeout(() => {
                  this.loading = false;
                }, 1000);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      /*setTimeout(() => {
        this.visible = false;
        this.loading = false;
      }, 3000);*/
    },
    handleCancel(e) {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.list-container {
  padding: 0 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; /* 或者使用 space-between 以在项目之间添加间距 */
  margin-top:12px;
}

.list-item {
  flex: 0 0 31.5%; /* 这将确保每个项目占据容器宽度的 1/3 */
  box-sizing: border-box; /* 确保 padding 和 border 不会增加元素的宽度 */
  margin-bottom: 24px; /* 可选：为每行项目添加底部间距 */
}
</style>
